export const OCC_ENDPOINTS = {
  anonymousSubscription: '/anonymous-subscription',
};
